import React from 'react';

const TermsConditionsView = () => {
    return (
        <div className="bg-white p-8 rounded-lg shadow-xl max-w-4xl mx-auto my-8">
            <h1 className="text-3xl font-bold text-sky-700 mb-6">Terms & Conditions</h1>
            <p className="text-gray-500 mb-4 text-sm">Last Updated: June 2026</p>
            
            <div className="space-y-6 text-gray-700 leading-relaxed">
                <section>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">1. Use of Platform</h2>
                    <p>By using QwickMed, you agree to provide accurate information and comply with all applicable pharmacy laws in India. This platform is for personal use only.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">2. Prescription Policy</h2>
                    <p>Orders for prescription medicines will only be processed upon validation of a legitimate prescription by our licensed pharmacists. We reserve the right to reject invalid or expired prescriptions.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">3. Pricing and Payment</h2>
                    <p>While we strive for accuracy, prices are subject to change based on actual MRP at the time of invoicing. Payment must be made at the time of delivery or as specified during checkout.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">4. Liability</h2>
                    <p>QwickMed is a platform facilitating medicine retail. Users are advised to consult their doctors before starting any medication. We are not liable for any misuse of medicines.</p>
                </section>
            </div>
        </div>
    );
};

export default TermsConditionsView;
